// @flow

import { connect } from 'react-redux';
import { WorkInfo } from '../../components/works';

const mapState = () => ({
  className: 'my-works',
  useMyWorksNoResults: true,
  title: 'My Works',
  backLinkTo: '/myworks',
  backLinkText: 'My works',
});

export default connect(
  mapState,
)(WorkInfo);
